import { useMemo } from "react";
import type { Trip } from "../types";
import { useTripContext } from "../state/trip-context";

export function useActiveTrip(): Trip | null {
  const { state } = useTripContext();
  return useMemo(() => {
    if (state.activeTripId === null) return null;
    return state.trips.find((trip) => trip.id === state.activeTripId) ?? null;
  }, [state.activeTripId, state.trips]);
}
